import Vue, { VueConstructor, PluginObject, PluginFunction, ComponentOptions } from 'vue';
import VueRouter from 'vue-router';

export interface ReactorContext {
    router: VueRouter;
    store: any;
    component?: any;
}

export interface ReactorOptions {
    store?: any | undefined,
    router?: VueRouter | undefined,
    reactions?: any
}

export type Reaction = (context: ReactorContext, payload: any, state: any) => any;

class reactorMixin {
    _reactor?: Function; // keep track of the subscription
    $options?: any;
    $store?: any;
    $router?: any;

    beforeCreate() {
        const options = this.$options;
        const reactions = options.reactions;
        if ((!reactions) || (!this.$store)) return;

        this._reactor = this.$store.subscribe((m: any, s: any) => {
            for (const key in reactions) {
                if (key === m.type) {
                    console.log('component reactor match for state', key);
                    const reaction = reactions[key];
                    if (Array.isArray(reaction)) {
                        reaction.forEach(r => {
                            r({ router: this.$router, component: this, store: this.$store }, m.payload, s);
                        })
                    } else {
                        reaction({ router: this.$router, component: this, store: this.$store }, m.payload, s);
                    }
                }
            }
        });
    }

    beforeDestroy() {
        const options = this.$options;
        const reactions = options.reactions;
        if (!this._reactor) return;

        this._reactor();
        delete this._reactor;
        this._reactor = undefined;
    }
};

export class VueReactor implements PluginObject<ReactorOptions> {
    private _options: ReactorOptions;

    constructor(options: ReactorOptions | undefined) {
        this._options = options || {};
    }

    install(v: VueConstructor<Vue>, options?: ReactorOptions){
        console.log('Vue Reactor launch', options);

        // watch for component reactions
        v.mixin(new reactorMixin());

        // merge options
        if (options) {
            this._options.store = options.store || this._options.store;
            this._options.router = options.router || this._options.router;
            this._options.reactions = options.reactions || this._options.reactions;
        }

        if (!!this._options.store && !!this._options.router && !!this._options.reactions) {
            const router: VueRouter = this._options.router;
            const reactions = this._options.reactions;
            const store = this._options.store;

            this._options.store.subscribe((m: any, s: any) => {
                for (const key in reactions) {
                    if (key === m.type) {
                        console.log('global reactor match for state', key);

                        const reaction = reactions[key];
                        if (Array.isArray(reaction)) {
                            reaction.forEach(r => {
                                r({ router, store }, m.payload, s);
                            })
                        } else {
                            reaction({ router, store }, m.payload, s);
                        }
                    }
                }
            });
        }
    }
}
